<template>
  <header class="header" :class="{ 'header--order-chat': isOrderChatTitle }" v-if="routeLayout.isHeader">
    <div class="inner">
      <div class="left" v-if="routeLayout.isBack">
        <button class="h-btn back" @click="fnBack"></button>
      </div>
      <div class="order-chat-title" v-if="isOrderChatTitle">
        <div class="order-chat-title__first-row">
          <span class="order-chat-title__type">{{ routeLayout.titleName.orderTypeLabel }}</span>
        </div>
        <div class="order-chat-title__order-no">
          {{ $t('admin.manage.order.label.no') }} {{ routeLayout.titleName.orderManageNo }}
        </div>
      </div>
      <div class="text" v-else-if="routeLayout.titleName">
        {{ $t(routeLayout.titleName) }}
      </div>

      <div class="area" v-if="routeLayout.isArea">
        <div class="header_btn">
          <button class="header_btn prev"></button>
        </div>

        <i class="i-current-position-pin" @click="setCurrentPosition" />
        <h1 class="header_tit text" @click="$router.push('/address/find?type=SEARCH')">
          <span class="headertit">
            {{ userPosition ?? $t('header.empty_address') }}
          </span>
          <p class="i-bottom"></p>
        </h1>
      </div>

      <div class="header_btn">
        <button class="i-home" v-if="routeLayout.isHome" @click="$router.push('/main')"></button>
        <button
          :class="['i-language', languageFlagClass]"
          v-if="route.name === 'MainIndex'"
          :aria-label="$t('modal.locale.title')"
          :title="$t('modal.locale.title')"
          @click="changeLocale"
        ></button>
        <button class="i-cart" v-if="routeLayout.isCart" @click="fnCart">
          <span class="count" v-if="true">{{ cartCount }}</span>
        </button>
        <button class="i-share" v-if="routeLayout.isShare" @click="share" />
        <button class="i-search" v-if="routeLayout.isSearch" @click="$router.push('/search')" />

        <button class="i-exit" v-if="routeLayout.isQuit" @click="exitChatRoom"></button>
      </div>
    </div>
  </header>
</template>

<script>
import { computed } from 'vue';
import { show, modalList } from '@/common/utils/ControlModal';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import Util from '@/common/utils/Util';
import store from '@/store';
import { useStore } from 'vuex';
import { remindScroll } from '@/common/utils/ScrollManager';

const layoutState = () => {
  const routeLayout = computed(() => {
    return store.getters['layout/getRouteLayout'];
  });
  const isOrderChatTitle = computed(() => {
    const titleName = routeLayout.value.titleName;
    return titleName !== null && typeof titleName === 'object' && titleName.kind === 'ORDER_CHAT';
  });
  return {
    routeLayout,
    isOrderChatTitle
  };
};

export default {
  name: 'the-header',
  setup() {
    const { getters, dispatch, commit } = useStore();
    const { go, push, replace } = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const fnBack = () => {
      const { query, path } = route;
      const pathList = ['/shop/dashboard', '/shop/store', '/promotion', '/new', '/cart'];
      const isRoot = Number(query?.isRoot ?? 0) > 0;
      const isChatRoom = /^\/room\/\d+\/(ORDER|INQUIRY)$/.test(path);

      // 메인 - 검색창 - 주소 변경 후 뒤로가기 시 메인으로 이동
      if (query.type === 'ADDRESS') {
        replace('/main');
        return;
      }

      console.log('path {}', path);

      if (isRoot && isChatRoom) replace('/chat/order?isRoot=1');
      else if (query?.togo) replace('/main?isRoot=1');
      else if (/\/my\/review\/[\d]+\/[\d]+\/[\d]+(\?.*)?/gi.test(path)) {
        replace(query.back);
      } else if (/^\/shop\/\d+\/product$/.test(path)) {
        console.log('store home!!');
        const toPath = store.getters['layout/getFromStorePath'];
        if (toPath) {
          if (pathList.includes(toPath) || toPath.includes('/search/result')) replace(`${toPath}`);
          else replace(`${toPath}?isRoot=1`);
        } else {
          replace('/main?isRoot=1');
        }
      } else if (/^\/promotion$/.test(path) || /^\/new$/.test(path) || path.includes('/search/result')) {
        replace('/main?isRoot=1');
      } else go(-1);
    };

    const { nativeShareUrl } = Util;

    const isDifferentSeller = computed(() => {
      const user = store.getters['user/getUserData'];
      const chat = store.getters['chat/getSelectedRoom'];
      const userStore = user?.store;
      const storeInfo = chat.store;

      if (user?.userNo === storeInfo?.userNo) return false;
      else return true;
    });

    const isSeller = computed(() => {
      const { isSeller } = store.getters['user/getUserData'];
      return isSeller;
    });

    const userPosition = computed(() => {
      const { address, addressDetail } = store.getters['user/getUserPosition'];
      if (!address) return null;
      else return `${address} ${addressDetail}`;
    });

    const cartCount = computed(() => {
      const cartWrapper = store.getters['cart/getCart'];
      const count = (cartWrapper.cart ?? []).reduce((prev, next) => {
        return prev + next.stock;
      }, 0);
      return count > 99 ? '99+' : count;
    });
    const currentLocale = computed(() => getters['locale/getLocale'] || 'ko');
    const languageFlagClass = computed(() => {
      const locale = currentLocale.value;
      if (locale === 'vn') return 'flag-vn';
      if (locale === 'en') return 'flag-en';
      return 'flag-ko';
    });

    const exitChatRoom = () => {
      show(modalList.Confirm, {
        title: t('modal.chat_exit.title'),
        text: t('modal.chat_exit.text'),
        confirmText: t('modal.chat_exit.confirmText'),
        rejectText: t('modal.chat_exit.rejectText'),
        confirmCallback: async () => {
          await store.dispatch('chat/leave');
          await store.dispatch('chat/LEAVE_CHAT_ROOM');

          const timeout = setTimeout(() => {
            clearTimeout(timeout);

            store.commit('layout/keepAlive', []);
            replace('/chat/inquiry');
          }, 500);
        }
      });
    };
    const fnCart = async () => {
      const isStoreProductScrollPath = /^\/shop\/\d+\/(product|search)$/.test(route.path);
      const isStoreInformationScrollPath = /^\/shop\/\d+\/information$/.test(route.path);
      const scrollPath = isStoreProductScrollPath || isStoreInformationScrollPath ? '/shop' : route.path;
      const payload = {};

      if (isStoreProductScrollPath) {
        const nextPage = Number(store.getters['store/getProductsPageInfo']?.page ?? 1);
        const storeCategoryNo = store.getters['store/getStoreCategoryNo'];

        payload.loadedPage = nextPage > 1 ? nextPage - 1 : 1;
        payload.searchText = typeof route.query.searchText === 'string' ? route.query.searchText : '';
        payload.storeCategoryNo = Util.isEmpty(storeCategoryNo) ? null : storeCategoryNo;
      }

      remindScroll(scrollPath, payload);

      await push('/cart');
    };
    const share = async () => {
      const { DYNAMIC_DOMAIN } = CODE_ENV_LIST;

      let uri;

      // 검색 화면 공유일 경우
      if (route.name === 'Search') {
        uri = `${DYNAMIC_DOMAIN}/link/dynamicLink${route.fullPath}`;
        const qs = store.getters['dynamiclink/getQuery'];
        if (qs) uri += `?searchText=${qs}`;
        // console.log(t('common.share_message', { dynamicLink: uri }));
        // nativeShareUrl(t('common.share_message', { dynamicLink: uri }));
        nativeShareUrl(uri);
        return;
      }

      // 상점, 상품 상세 공유일 경우
      let params = {
        storeNo: route.params.storeNo,
        productNo: route.params.productNo
      };

      if (params.productNo) {
        uri = `${DYNAMIC_DOMAIN}/link/dynamicLink/product/${params.storeNo}/${params.productNo}`;
      } else {
        uri = `${DYNAMIC_DOMAIN}/link/dynamicLink/store/${params.storeNo}`;
      }

      // console.log(t('common.share_message', { dynamicLink: uri }));
      // nativeShareUrl(t('common.share_message', { dynamicLink: uri }));
      nativeShareUrl(uri);
    };

    const setCurrentPosition = () => {
      console.log('?');
      store.dispatch('user/GET_CURRENT_POSITION');
    };
    const changeLocale = () => show(modalList.Locale, null);
    return {
      route,
      cartCount,
      languageFlagClass,
      userPosition,
      isSeller,
      isDifferentSeller,
      ...layoutState(),
      fnBack,
      exitChatRoom,
      share,
      setCurrentPosition,
      changeLocale,
      fnCart
    };
  }
};
</script>

<style scoped lang="scss">
.header_tit.text {
  //max-width: 20rem !important;
  //overflow: hidden;
  //text-overflow: ellipsis;
  //white-space: nowrap;
}

.header--order-chat {
  height: 5.6rem;

  .inner {
    min-width: 0;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;

    .left,
    .header_btn {
      flex: 0 0 auto;
    }
  }
}

.order-chat-title {
  flex: 1 1 0;
  min-width: 0;
  margin: 0 0.8rem;
  overflow: hidden;
  font-weight: 500;

  &__first-row {
    display: flex;
    min-width: 0;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    line-height: 1.6rem;
  }

  &__type {
    min-width: 0;
    overflow: hidden;
    font-size: 1.3rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__time {
    flex: 0 0 auto;
    font-size: 1.2rem;
    white-space: nowrap;
  }

  &__order-no {
    min-width: 0;
    margin-top: 0.2rem;
    overflow: hidden;
    font-size: 1.5rem;
    line-height: 1.8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
